// extracted by mini-css-extract-plugin
export default {"root":"_2K14u","image":"r0EvP","large":"_3Furv","medium":"_3p40p","small":"y2tb-"};